export default {
  /* po-mo style translations start */
  "Checking the status of an application": "Проверка статуса заявки",
  "Here you can check the status of the application": "Здесь можно проверить статус заявки",
  'Your application is pending': 'Ваше завление находится на рассмотрении',
  'Your application has been approved': 'Ваша заявка была одобрена',
  'You have been denied a place in a dormitory': 'Вам было отказано в предоставлении места в общежитии',
  /* po-mo style translations end */

  full_name: 'Полное имя',
  application_reviewing: 'Ваше завление находится на рассмотрении',
  application_approved: 'Ваша заявка была одобрена',
  application_rejected: 'Вам было отказано в предоставлении места в общежитии',

  admin: {
    study_place: 'Место обучения',
    payment_method: 'Способ оплаты',
    application_status: 'Статус заявки',
    status: 'Статус заявки',
    settlement_status: 'Статус заселения',
    social_status: 'Социальный статус',
  },

  kafu: {
    title: 'Казахстанско-американский свободный университет',
    description: `Городской вуз международного партнерства / Государственная лицензия АБ
    0137478 Международная аккредитация ACBSP (США) / Институциональная и
    специализированная аккредитация НКАОКО (Казахстан)`,
    contacts: 'Номера приёмной коммисии',
    address: 'Адрес общежития: проспект Шакарима 160',
    phone: 'Телефон общежития: 50-50-81'
  },

  form: {
    uni_title: 'Казахстанско-американский свободный университет',
    uni_description: `Городской вуз международного партнерства / Государственная лицензия АБ
    0137478 Международная аккредитация ACBSP (США) / Институциональная и
    специализированная аккредитация НКАОКО (Казахстан)`,
    contacts_title: 'Номера приёмной коммисии',
    address_title: '',
    contacts_col: `
    <p>
      <a href="tel:87232500300">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)500-300
      </a>
      <br />
      <a href="tel:87232505030">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        8(7232)50-50-30
      </a>
      <br />
      <a href="tel:77074400001">
        <i aria-hidden="true" class="fas fa-phone-alt mr-2"></i>
        +7-707-440-00-01
      </a>
      <br />
    </p>
    `,
    address_col: `
    <div>Адрес общежития: проспект Шакарима 160</div>
    <div>Телефон общежития: 50-50-81</div>
    `,

    form_title: 'Форма приёма заявок в общежития',
    select_placeholder: 'Выберите из списка',
    other_placeholder: 'Другое',
    choose_btn: 'Выбрать',
    search: 'Поиск',
    closed: 'Приём заявок закрыт',
    reset_btn: 'Сбросить',
    load_btn: 'Загрузить',
    cancel_btn: 'Отмена',

    personal_data_title: 'Персональные данные',
    contact_info_title: 'Контактная информация',
    additional_info_title: 'Дополнительная информация',
    vac_doc: 'Паспорт вакцинации',
    last_name: 'Фамилия по документам',
    first_name: 'Имя',
    middle_name: 'Отчество',
    gender: {
      title: 'Пол',
      male: 'мужской',
      female: 'женский',
    },
    iin: 'ИИН',
    study_place: 'Место обучения',
    course: 'Курс',
    payment_method: 'Форма оплаты',
    address: 'Место прописки',
    address_tooltip:
      'Заполните следующим образом: Страна, область, город, улица, дом, квартира',
    address_placeholder: 'Страна, область, город, улица, дом, квартира',

    country: 'Страна',
    region: 'Область',
    city: 'Название населенного пункта(город, село и т.д)',
    city_placeholder: 'г.Астана',
    street: 'Улица',
    house: 'Дом',
    flat: 'Квартира',
    private_house: 'Частный дом',
    uk_rejection_message: 'Для лиц проживающих в г.Усть-Каменогорске общежитие не выделяется',

    email: 'Email',
    phone: 'Контактный телефон',
    social_status: {
      label: 'Социальное положение',
      title: 'Выберите социальное положение',
    },
    social_status_tooltip:
      'Выберите статус из списка и прикрепите подтверждающий документ',
    social_status_doc: 'Подтверждающий социальный статус документ',
    submit_btn: 'Отправить',
    submitted: 'Ваша заявка отправлена',

    errors: {
      first_name: 'Укажите ваше имя!',
      last_name: 'Укажите вашу фамилию!',
      gender: 'Укажите пол!',
      iin: 'ИИН должен содержать 12 цифр!',
      study_place: 'Укажите место обучения!',
      payment_method: 'Укажите формат оплаты!',
      address: 'Укажите адрес прописки!',
      email: 'Укажите ваш email!',
      phone: 'Укажите ваш номер телефона!',
      social_status_doc:
        'Прикрепите документ подтверждающий социальный статус!',
    },
  },
  article: {
    back_btn: 'Назад к форме подачи заявки'
  }
}
